import { introJs } from 'intro.js'
import 'intro.js/introjs.css';
import 'intro.js/themes/introjs-modern.css';
import './index.css';

/**
 * 默认步骤
 */
const STEPS_DEFAULT = [{
  element: '#step1',
  intro: '<h3>步骤一</h3>天青色等烟雨，而我在等你，岁月被打捞起，掩盖了结局。',
  position: 'right',
  event: function () {
    console.log('step1');
  }
},
{
  element: '#step2',
  intro: '<h3>步骤二</h3>在瓶底书汉隶仿前朝的飘逸，就当我为遇见你伏笔。',
  position: 'right',
  event: function () {
    console.log('step2');
  }
},
{
  element: '#step3',
  intro: "<h3>步骤三</h3>炊烟袅袅升起，隔江千万里，如传世的青花瓷自顾自美丽，你眼带笑意。",
  position: 'top',
  event: function () {
    console.log('step3');
  }
}];

/**
 * 类-用户体验引导组件
 */
export default class WeaToolIntro {
  constructor(steps = STEPS_DEFAULT) {
    this.intro = introJs();
    this.steps = steps;
  }
  init() {
    this.intro.setOptions({
      nextLabel: "下一步",
      prevLabel: "上一步",
      skipLabel: "跳过",
      doneLabel: "知道了",
      showProgress: false,
      showStepNumbers: false,
      exitOnOverlayClick: false,
      showBullets: false,
      steps: this.steps
    });
    this.intro.onchange(targetElement => {
      const element = this.steps.find(item => item.element === `#${targetElement.id}`);
      element.event ? element.event() : console.log('no event');
    })
  }
  start() {
    this.init();
    this.intro.start();
  }
}